import { GroupClassroomContent as Content } from "content";
import { CoverButton } from "components/Interactive/CoverButton";
import { Space } from "components/Common/Space";
import { Paragraph } from "components/Typography/Paragraph";
import "./GroupClassroomEmpty.styles.scss";

type TGroupClassroomEmptyProps = {
  /**
   * Add material for group mouse button click handler
   * @param event - mouse event
   */
  onAddClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const GroupClassroomEmpty: React.FC<TGroupClassroomEmptyProps> = (
  props
) => {
  const { onAddClick } = props;

  return (
    <Space
      direction="vertical"
      size="medium"
      align="center"
      justify="center"
      fullWidth
      className="nb-sub-group-classroom-empty-wrapper"
    >
      <div className="nb-sub-group-classroom-empty-button-wrapper">
        <CoverButton
          onClick={onAddClick}
          className="nb-sub-group-classroom-empty-button"
        >
          {Content.Empty.LABEL}
        </CoverButton>
        <img
          src="/assets/images/other/1.png"
          width={197}
          height={301}
          aria-hidden="true"
          className="nb-sub-group-classroom-empty-button-image"
        />
      </div>
      <Paragraph variant={2} className="nb-sub-group-classroom-empty-message">
        {Content.Empty.MESSAGE}
      </Paragraph>
    </Space>
  );
};
